import React from 'react';
import { HelpCircle } from 'lucide-react';
import { useManual } from './ManualContext.shared';

const ManualButton: React.FC = () => {
    const { openManual, currentStep, isOpen } = useManual();

    // Optionally, hide the button if there is no manual data for the current page
    if (!currentStep) {
        return null;
    }

    // Also hide if already open (though styling handles z-index, it's cleaner)
    if (isOpen) return null;

    return (
        <button
            onClick={openManual}
            className="fixed bottom-[80px] md:bottom-6 right-6 z-40 flex items-center justify-center text-white transition-all duration-300 transform hover:-translate-y-1 group animate-in fade-in slide-in-from-bottom-4"
            style={{
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #7c3aed, #6d28d9)',
                boxShadow: '0 10px 20px rgba(124, 58, 237, 0.3)'
            }}
            aria-label="Deschide Manualul de Utilizare"
            title="Ghid de Utilizare"
        >
            <HelpCircle size={22} className="text-white" strokeWidth={2.5} />
        </button>
    );
};

export default ManualButton;
